'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselNav", {
    enumerable: true,
    get: function() {
        return CarouselNav;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _CarouselNavContext = require("./CarouselNavContext");
const _renderCarouselNav = require("./renderCarouselNav");
const _useCarouselNav = require("./useCarouselNav");
const _useCarouselNavStylesstyles = require("./useCarouselNavStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselNav = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselNav.useCarouselNav_unstable)(props, ref);
    const contextValues = (0, _CarouselNavContext.useCarouselNavContextValues_unstable)(state);
    (0, _useCarouselNavStylesstyles.useCarouselNavStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselNavStyles_unstable')(state);
    return (0, _renderCarouselNav.renderCarouselNav_unstable)(state, contextValues);
});
CarouselNav.displayName = 'CarouselNav';
